import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';

import { QueryResultsModel } from '../../_base/crud';
import { Note } from '../_models/note.model';
import { NoteState } from '../_reducers/note.reducer';

export const selectNoteState = createFeatureSelector<NoteState>('note');

export const selectNotePageLoading = createSelector(selectNoteState, (state) => state.pageLoading);

export const selectNoteActionLoading = createSelector(
  selectNoteState,
  (state) => state.actionLoading,
);

export const selectNoteQuery = createSelector(selectNoteState, (state) => state.query);

export const selectNoteShowInitWaitingMessage = createSelector(
  selectNoteState,
  (state) => state.showInitWaitingMessage,
);

export const selectNoteError = createSelector(selectNoteState, (state) => state.error);

export const selectNotePage = createSelector(selectNoteState, (state) => {
  const notes: Note[] = [];
  each(state.ids, (id: number) => notes.push(state.entities[id]));

  return new QueryResultsModel(notes, state.totalCount);
});
